import { Tabs } from '@mantine/core';

import classes from './tab.module.css';

export const TabTheme = Tabs.extend({
	classNames: (_theme, props) =>
		props.variant === 'vertical-sidebar'
			? { list: classes.list, tab: classes.tab, panel: classes.panel }
			: {},
});
